<template>
    <p class="posi-relative input-container flex">
        <!--密码输入框input-->
        <input :type="typeOver" :id='id' :value='value' :class="classCpt" :style="styleCpt" 
            :maxlength="maxlength" :placeholder="placeholder?placeholder:placeholderOVer" 
            :autofocus="autofocus" @click="$emit('click')" ref="inputHandle" v-on="inputListeners" />
		<template v-if="isShowClear">
			<!-- 清除 -->
			<img @click="clearInput" class="clear" src="../../assets/img/kcsc.png" >
			 <!-- 关眼睛 -->
			<img v-if="typeOver=='password'" @click="typeOver = 'text'" class="yj_g" src="../../assets/img/yj_g.png">
			<!-- 闭眼睛 -->
			<img v-if="typeOver=='text'" @click="typeOver='password'" class="yj_k" src="../../assets/img/yj_k.png">
		</template>
     </p>
</template>

<script>
	export default{
		inheritAttrs: false, //根元素不继承特性
		mounted(){
            //-- 如果设定了数据框的 类型
			if(this.type){ 
				this.typeOver = this.type;
			}
			//-- 如果设定了样式
			if(this.styleCpt){ 
				this.styleOver = this.styleCpt;
			}
			//-- 如果设置了提示语
			if(this.placeholder){ 
				this.placeholderOVer = this.placeholder;
            }
		},
        props:['id','styleCpt','classCpt','placeholder','autofocus','readonly','maxlength'],
		data(){
			return{
				typeOver:'password', //-- 默认输入框为 文本框
				value:'',
				styleOver:'', //-- 样式
				isFocus:false, //-- 是否获得焦点
				placeholderOVer:'请输入您的基金交易密码', //-- 默提示语
				isShowClear:false
			}
		},
		computed:{
			inputListeners:function(){
				let vm = this;
				//Object.assign 将所有的对象合并为一个新对象
				return Object.assign(
					{},
					//-- 我们从父级添加所有的监听器
					this.$listeners,
					//-- 然后我们添加定义监听器，或覆写一些监听器行为
					{
						//-- 这里确保组件配合 `v-model` 的工作
				        input: (event) => {
							vm.$emit('input', event.target.value)
							vm.value = event.target.value;
				        },
				        //-- 获得焦点事件
				        onfocus: () => { vm.$emit('onfocus') },
				        //-- 失去焦点事件
				        onblur: () => { vm.$emit('onblur') },
					}
				)
			}
		},
		watch:{
			value(newVal,oldVal){				
				if(newVal == ''){
					this.isShowClear = false;
				}else{
					this.isShowClear = true; //显示清除按钮
					// 不能输入空
					if(newVal.substr(-1) == ' '){
						this.value =oldVal;
					}else if(newVal.length > 20){	 //-- 检测密码不能超过 16 位
						this.value = oldVal;
					}
                }
                this.$emit('input',this.value.trim());
			}
		},
		methods: {
			//-- 一键清除 input 的值
			clearInput(){
                this.value = '';  
                this.$emit('input',this.value.trim());
				//-- 清除后 并 获得焦点
				this.$refs.inputHandle.focus()
			}
		},
	}
</script>

<style scoped lang="less">
	.input-container{
        input{
			flex: 1 ;
		}
		img{			 
			position: absolute;
			cursor: pointer;
			height: .8rem;
			top: .7rem;
		}	
		//清除
		img.clear{
			width: .8rem;
			right: 2.6rem;
			 
		}
		//闭眼睛与开眼睛的样式
		img.yj_g,img.yj_k{
			width: 1.2rem;
			right: 1rem;
		}
		//闭眼睛
		img.yj_g{
			height:.55rem;
			top: .9rem;
		}
		//清除图片的hover
		img.clear:hover{
			height: .9rem;
			width: .9rem; 
			top: .65rem;
		}
	}
	
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/inputPwd.vue